// data.jsx — sample program data
import { recordTimes } from './sync.js';
// Generic 4-day upper/lower full-body hypertrophy split.
// Rep ranges + double-progression targets, no branded content.

const PROGRAM = {
  name: 'Full Body Transformation',
  author: 'You',
  weeks: 12,
  currentWeek: 6,
  split: '4 days · Upper / Lower',
  days: [
    {
      id: 'ua', name: 'Upper A', day: 'Mon',
      exercises: [
        { id: 'e1', name: 'Incline Smith Press', group: 'Chest', sets: 3, repMin: 6, repMax: 8, target: { w: 135, r: 8 }, last: { w: 130, reps: [8,8,7] }, rest: 180 },
        { id: 'e2', name: 'Chest-Supported Row', group: 'Back', sets: 3, repMin: 8, repMax: 10, target: { w: 115, r: 10 }, last: { w: 110, reps: [10,10,9] }, rest: 150 },
        { id: 'e3', name: 'Standing DB Shoulder Press', group: 'Shoulders', sets: 2, repMin: 8, repMax: 10, target: { w: 45, r: 10 }, last: { w: 40, reps: [10,9] }, rest: 120 },
        { id: 'e4', name: 'Lat Pulldown (wide)', group: 'Back', sets: 2, repMin: 10, repMax: 12, target: { w: 140, r: 12 }, last: { w: 140, reps: [12,11] }, rest: 120 },
        { id: 'e5', name: 'Cable Lateral Raise', group: 'Shoulders', sets: 3, repMin: 12, repMax: 15, target: { w: 15, r: 15 }, last: { w: 12.5, reps: [15,14,12] }, rest: 90 },
        { id: 'e6', name: 'EZ-Bar Curl', group: 'Biceps', sets: 2, repMin: 8, repMax: 10, target: { w: 55, r: 10 }, last: { w: 50, reps: [10,10] }, rest: 90 },
        { id: 'e7', name: 'Cable Triceps Pushdown', group: 'Triceps', sets: 2, repMin: 10, repMax: 12, target: { w: 50, r: 12 }, last: { w: 45, reps: [12,12] }, rest: 90 },
      ],
    },
    {
      id: 'la', name: 'Lower A', day: 'Tue',
      exercises: [
        { id: 'l1', name: 'Back Squat', group: 'Quads', sets: 3, repMin: 5, repMax: 7, target: { w: 225, r: 7 }, last: { w: 215, reps: [7,7,6] }, rest: 210 },
        { id: 'l2', name: 'Romanian Deadlift', group: 'Hamstrings', sets: 3, repMin: 8, repMax: 10, target: { w: 185, r: 10 }, last: { w: 175, reps: [10,10,10] }, rest: 180 },
        { id: 'l3', name: 'Leg Press', group: 'Quads', sets: 2, repMin: 10, repMax: 12, target: { w: 360, r: 12 }, last: { w: 340, reps: [12,12] }, rest: 150 },
        { id: 'l4', name: 'Seated Leg Curl', group: 'Hamstrings', sets: 2, repMin: 10, repMax: 12, target: { w: 110, r: 12 }, last: { w: 100, reps: [12,11] }, rest: 90 },
        { id: 'l5', name: 'Standing Calf Raise', group: 'Calves', sets: 3, repMin: 8, repMax: 10, target: { w: 180, r: 10 }, last: { w: 170, reps: [10,10,9] }, rest: 90 },
        { id: 'l6', name: 'Weighted Plank', group: 'Core', sets: 3, repMin: 30, repMax: 45, target: { w: 25, r: 45 }, last: { w: 25, reps: [45,40,35] }, rest: 60, unit: 'sec' },
      ],
    },
    {
      id: 'ub', name: 'Upper B', day: 'Thu',
      exercises: [
        { id: 'u1', name: 'Weighted Pull-up', group: 'Back', sets: 3, repMin: 5, repMax: 7, target: { w: 25, r: 7 }, last: { w: 20, reps: [7,6,6] }, rest: 180 },
        { id: 'u2', name: 'Flat DB Bench Press', group: 'Chest', sets: 3, repMin: 8, repMax: 10, target: { w: 75, r: 10 }, last: { w: 70, reps: [10,10,9] }, rest: 150 },
        { id: 'u3', name: 'Machine Shoulder Press', group: 'Shoulders', sets: 2, repMin: 8, repMax: 10, target: { w: 120, r: 10 }, last: { w: 110, reps: [10,10] }, rest: 120 },
        { id: 'u4', name: 'Cable Row (neutral)', group: 'Back', sets: 2, repMin: 10, repMax: 12, target: { w: 145, r: 12 }, last: { w: 140, reps: [12,12] }, rest: 120 },
        { id: 'u5', name: 'Pec Deck', group: 'Chest', sets: 2, repMin: 12, repMax: 15, target: { w: 110, r: 15 }, last: { w: 100, reps: [15,13] }, rest: 90 },
        { id: 'u6', name: 'Preacher Curl', group: 'Biceps', sets: 2, repMin: 10, repMax: 12, target: { w: 40, r: 12 }, last: { w: 35, reps: [12,12] }, rest: 90 },
        { id: 'u7', name: 'Overhead Cable Extension', group: 'Triceps', sets: 2, repMin: 10, repMax: 12, target: { w: 60, r: 12 }, last: { w: 55, reps: [12,12] }, rest: 90 },
      ],
    },
    {
      id: 'lb', name: 'Lower B', day: 'Fri',
      exercises: [
        { id: 'b1', name: 'Conventional Deadlift', group: 'Back', sets: 2, repMin: 4, repMax: 6, target: { w: 285, r: 6 }, last: { w: 275, reps: [6,5] }, rest: 240 },
        { id: 'b2', name: 'Bulgarian Split Squat', group: 'Quads', sets: 3, repMin: 8, repMax: 10, target: { w: 40, r: 10 }, last: { w: 35, reps: [10,10,9] }, rest: 150 },
        { id: 'b3', name: 'Hip Thrust', group: 'Glutes', sets: 3, repMin: 8, repMax: 10, target: { w: 245, r: 10 }, last: { w: 225, reps: [10,10,10] }, rest: 150 },
        { id: 'b4', name: 'Hack Squat', group: 'Quads', sets: 2, repMin: 10, repMax: 12, target: { w: 270, r: 12 }, last: { w: 250, reps: [12,11] }, rest: 120 },
        { id: 'b5', name: 'Lying Leg Curl', group: 'Hamstrings', sets: 2, repMin: 10, repMax: 12, target: { w: 90, r: 12 }, last: { w: 85, reps: [12,12] }, rest: 90 },
        { id: 'b6', name: 'Seated Calf Raise', group: 'Calves', sets: 3, repMin: 12, repMax: 15, target: { w: 90, r: 15 }, last: { w: 80, reps: [15,14,13] }, rest: 60 },
        { id: 'b7', name: 'Ab Wheel Rollout', group: 'Core', sets: 3, repMin: 8, repMax: 12, target: { w: 0, r: 12 }, last: { w: 0, reps: [12,10,10] }, rest: 60 },
      ],
    },
  ],
};

// Exercise-level static notes (form cues, setup) + cross-session note history.
// Keyed by exercise name so we can look up for any exercise in the program.
const EXERCISE_NOTES = {
  'Back Squat': {
    pinned: 'High-bar, heels on 5-lb plates. Breathe into belt before unrack. Knees track over mid-foot.',
    substitutes: ['Front Squat', 'Hack Squat', 'Leg Press', 'Belt Squat'],
    cues: ['Brace before descent', 'Chest up out of the hole', 'Drive knees out'],
    history: [
      { date: 'Apr 15', session: 'Lower A · W5', body: 'Left hip felt tight on warmups. Foam rolled 3 min, cleared up by set 2.', tag: 'Mobility' },
      { date: 'Apr 8',  session: 'Lower A · W4', body: "Felt strong — bar speed was fast on top set. Could've added 5 lb sooner.", tag: 'PR' },
      { date: 'Apr 1',  session: 'Lower A · W3', body: 'Lost brace on rep 6 of set 3, shortened ROM. Focus on air before each rep.', tag: 'Form' },
      { date: 'Mar 25', session: 'Lower A · W2', body: 'Tried a narrower stance — felt more quad drive. Keeping this.', tag: 'Setup' },
    ],
  },
  'Romanian Deadlift': {
    pinned: 'Soft knees, push hips back until stretch at bottom of hamstrings. Bar stays in contact with legs.',
    substitutes: ['Stiff-Leg Deadlift', 'Good Morning', 'Single-Leg RDL', '45° Back Extension'],
    cues: ['Lat tension before descent', 'Feel the stretch', 'Squeeze glutes at top'],
    history: [
      { date: 'Apr 15', session: 'Lower A · W5', body: 'Used straps. Grip was the limit last week.', tag: 'Equipment' },
      { date: 'Apr 1',  session: 'Lower A · W3', body: 'Stretch was deep — felt it well.', tag: 'Form' },
    ],
  },
  'Leg Press': {
    pinned: "Feet mid-platform, shoulder-width. Don't lock out. Control the eccentric.",
    substitutes: ['Hack Squat', 'Smith Squat', 'Belt Squat'],
    cues: ['Full ROM', 'Push through heels'],
    history: [
      { date: 'Apr 15', session: 'Lower A · W5', body: 'Added long-length partials after last set — 6 more after failure.', tag: 'Technique' },
    ],
  },
  'Seated Leg Curl': {
    pinned: 'Pad just above ankles. Pause briefly in the fully-contracted position.',
    substitutes: ['Lying Leg Curl', 'Nordic Curl'],
    cues: ['Slow eccentric', 'Squeeze at bottom'],
    history: [],
  },
  'Standing Calf Raise': {
    pinned: 'Full stretch at bottom. 2s pause at top.',
    substitutes: ['Seated Calf Raise', 'Smith Calf Raise', 'Donkey Calf Raise'],
    cues: ['Stretch', 'Pause', "Don't bounce"],
    history: [],
  },
  'Weighted Plank': {
    pinned: 'Plate on upper back. Glutes + quads tight the entire time.',
    substitutes: ['Dead Bug', 'Hollow Body Hold', 'RKC Plank'],
    cues: ["Don't let hips drop", 'Breathe through nose'],
    history: [],
  },
};

// Intensity techniques — these can be added to individual sets.
// Each alters the set card and may add a follow-up mini-set.
const INTENSITY_TECHNIQUES = [
  { id: 'normal',    name: 'Standard set',      abbr: 'STD', color: null, desc: 'Straight set to target reps' },
  { id: 'llp',       name: 'Long-length partials', abbr: 'LLP', color: 'pr', desc: 'After failure, do partials in the stretched range' },
  { id: 'drop',      name: 'Drop set',          abbr: 'DROP',color: 'info', desc: 'To failure → drop weight ~20% → continue without rest' },
  { id: 'myo',       name: 'Myo-reps',          abbr: 'MYO', color: 'info', desc: 'Activation set, then clusters of 3–5 with 15s rest' },
  { id: 'rp',        name: 'Rest-pause',        abbr: 'RP',  color: 'info', desc: 'Failure → 15s rest → as many as possible, repeat' },
  { id: 'cluster',   name: 'Cluster set',       abbr: 'CLS', color: 'info', desc: 'Break set into mini-sets with short intra-rest' },
  { id: 'amrap',     name: 'AMRAP (last set)',  abbr: 'AMRAP',color: 'pr',  desc: 'Final set to technical failure, log all reps' },
  { id: 'warmup',    name: 'Warm-up',           abbr: 'WU',  color: 'mute',desc: 'Doesn\'t count toward working volume' },
];

// Progress history (weekly est. 1RM on compounds, 12 weeks)
const HISTORY = {
  'Back Squat':   [205, 210, 210, 215, 215, 220, 220, 225, 225, 230, 230, 235],
  'Incline Smith Press': [115, 120, 120, 125, 130, 130, 135, 135, 140, 140, 145, 145],
  'Conventional Deadlift': [245, 255, 255, 265, 265, 275, 275, 280, 285, 285, 290, 295],
  'Weighted Pull-up': [5, 10, 10, 12.5, 15, 15, 20, 20, 25, 25, 27.5, 30],
};

// Typical workout activity heatmap (12 weeks × 7 days, sparse)
const ACTIVITY = [
  [1,1,0,1,1,0,0],[1,1,0,1,1,0,0],[1,1,0,1,1,0,0],[1,0,0,1,1,0,0],
  [1,1,0,1,1,0,0],[1,1,0,1,1,0,0],[1,1,0,1,0,0,0],[1,1,0,1,1,0,0],
  [1,1,0,1,1,0,0],[1,1,0,1,1,0,0],[0,1,0,1,1,0,0],[1,1,0,0,0,0,0],
];

// ═══════════════════════════════════════════════════════════════════════
// Phase 24: JSON state export + import helpers
// ═══════════════════════════════════════════════════════════════════════
//
// Schema:
//   {
//     "schemaVersion": 1,
//     "exportedAt": "ISO timestamp",
//     "app": "liftlog",
//     "sessions": [...],  "prs": [...],  "programs": [...],  "exercises": [...],
//     "bodyEntries": [...], "measurements": [...],
//     "prefs": {...},  "user": { pro: boolean }
//   }
//
// Photos are EXCLUDED per DEC-json-photo-skip-v2.1 — they live as Blobs in
// Dexie IndexedDB and are not serialized to JSON. Ephemeral state
// (toasts, activeSessionId) is also excluded.

function exportStateJSON(state, opts) {
  const include = (opts && opts.include) || { sessions: true, prs: true, body: true, programs: true };
  const payload = {
    schemaVersion: 1,
    exportedAt: new Date().toISOString(),
    app: 'liftlog',
  };
  // Finished workouts only: a workout in progress is not part of a backup.
  if (include.sessions) payload.sessions = Array.isArray(state && state.sessions) ? state.sessions.filter((s) => s && s.completedAt) : [];
  if (include.prs) payload.prs = Array.isArray(state && state.prs) ? state.prs : [];
  if (include.programs) {
    payload.programs = Array.isArray(state && state.programs) ? state.programs : [];
    // Exercises ship with programs — a program without its exercise library is unreferenceable.
    payload.exercises = Array.isArray(state && state.exercises) ? state.exercises : [];
  }
  if (include.body) {
    payload.bodyEntries = Array.isArray(state && state.bodyEntries) ? state.bodyEntries : [];
    payload.measurements = Array.isArray(state && state.measurements) ? state.measurements : [];
  }
  // prefs always included — UI settings are part of a meaningful backup.
  payload.prefs = (state && typeof state.prefs === 'object' && state.prefs) ? state.prefs : {};
  // user.pro is persistent post-Phase-23b; trialEndsAt is ephemeral-ish but cheap to include.
  if (state && state.user) {
    payload.user = { pro: !!state.user.pro, name: state.user.name || '' };
  }
  // A restore on a new phone gets the same active program, onboarding profile and name.
  payload.activeProgramId = (state && state.activeProgramId) || null;
  payload.profile = (state && state.profile) || null;
  payload.welcomed = !!(state && state.welcomed);
  // Each record's last edit time: a restore dates records by these, so restoring
  // this file on a synced phone never outranks edits made elsewhere before it.
  try { payload.times = recordTimes(); } catch (_) { /* no edit index (tests) */ }
  return JSON.stringify(payload, null, 2);
}

function parseStateJSON(text) {
  let parsed;
  try {
    parsed = JSON.parse(text);
  } catch (e) {
    const err = new Error('Invalid JSON — file may be corrupted or wrong format');
    err.code = 'PARSE_ERROR';
    throw err;
  }
  if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
    const err = new Error('JSON root must be an object');
    err.code = 'SHAPE_ERROR';
    throw err;
  }
  if (parsed.app !== 'liftlog') {
    const err = new Error('This does not appear to be a Lift Log backup');
    err.code = 'APP_MISMATCH';
    throw err;
  }
  if (parsed.schemaVersion !== 1) {
    const err = new Error('This backup was created with schemaVersion ' + parsed.schemaVersion + '. Current app supports schemaVersion 1.');
    err.code = 'VERSION_MISMATCH';
    throw err;
  }
  // Phase 34: additive-import recognition — a program-package carries kind:'program-package'
  // instead of a programs[] array. Validate shape here before importProgram ever receives it
  // (defense-in-depth for IMP-03: non-corrupting import). Full-backup path below is unchanged.
  if (parsed.kind === 'program-package') {
    if (
      !parsed.program ||
      typeof parsed.program !== 'object' ||
      Array.isArray(parsed.program) ||
      !Array.isArray(parsed.program.days) ||
      parsed.program.days.length === 0
    ) {
      const err = new Error('Program package is missing its program data');
      err.code = 'PACKAGE_SHAPE_ERROR';
      throw err;
    }
    const stats = {
      sessions: 0,
      prs: 0,
      programs: 1,
      exercises: 0,
      bodyEntries: 0,
      measurements: 0,
      exportedAt: parsed.exportedAt || null,
      kind: parsed.kind,
    };
    return { snapshot: parsed, stats };
  }
  // Phase 35: sessions-package — ADDITIVE import of logged sessions.
  // Validates the sessions array; carries ambiguities/meta for the dry-run UI.
  // Never routes through applyStateJSON (REPLACE) — importLoggedSessions is the commit action.
  if (parsed.kind === 'sessions-package') {
    if (!Array.isArray(parsed.sessions)) {
      const err = new Error('Sessions package is missing sessions array');
      err.code = 'PACKAGE_SHAPE_ERROR';
      throw err;
    }
    const stats = {
      sessions:     parsed.sessions.length,
      prs:          0,
      programs:     0,
      exercises:    Array.isArray(parsed.exercisesToCreate) ? parsed.exercisesToCreate.length : 0,
      bodyEntries:  0,
      measurements: 0,
      exportedAt:   parsed.exportedAt || null,
      kind:         parsed.kind,
      ambiguities:  Array.isArray(parsed.ambiguities) ? parsed.ambiguities : [],
      meta:         parsed.meta || {},
    };
    return { snapshot: parsed, stats };
  }
  const stats = {
    sessions: Array.isArray(parsed.sessions) ? parsed.sessions.length : 0,
    prs: Array.isArray(parsed.prs) ? parsed.prs.length : 0,
    programs: Array.isArray(parsed.programs) ? parsed.programs.length : 0,
    exercises: Array.isArray(parsed.exercises) ? parsed.exercises.length : 0,
    bodyEntries: Array.isArray(parsed.bodyEntries) ? parsed.bodyEntries.length : 0,
    measurements: Array.isArray(parsed.measurements) ? parsed.measurements.length : 0,
    exportedAt: parsed.exportedAt || null,
  };
  return { snapshot: parsed, stats };
}

export { PROGRAM, HISTORY, ACTIVITY, EXERCISE_NOTES, INTENSITY_TECHNIQUES, exportStateJSON, parseStateJSON };
